import { useState } from "react";
import { Sidebar, ISidebarProps } from "../../../Components/SideBar/Sidebar";
import { useIntl } from "react-intl";
import { IListItemLinkProps } from "../../../Components/ListItemLink/ListItemLink";
import {
  People,
  Person,
  Description,
  AccountTree,
  NoteAdd,
} from "@material-ui/icons";
import { useSelector } from "react-redux";

export const MlsSideBar = (props: ISidebarProps) => {
  const { currentUser } = useSelector((state: any) => ({
    currentUser: state?.UserReducer?.currentUser,
  }));
  const { formatMessage } = useIntl();
  const [userRole, setUserRole] = useState(currentUser.role);

  const itemClient: IListItemLinkProps[] = [
    {
      to: "/ms/process",
      text: formatMessage({
        id: "process.side.title",
        defaultMessage: "Process",
      }),
      icon: <AccountTree />,
    },
    {
      to: "/ms/document",
      text: formatMessage({
        id: "component.sidebar.document",
        defaultMessage: "Document",
      }),
      icon: <Description />,
    },
    {
      to: "/ms/administrations",
      text: formatMessage({
        id: "document.sidebar.group",
        defaultMessage: "Document Group",
      }),
      icon: <NoteAdd />,
    },
    // {
    //   to: "/ms/users",
    //   text: formatMessage({
    //     id: "admin.users.header",
    //     defaultMessage: "Users",
    //   }),
    //   icon: <Person />,
    // },
    // {
    //   to: "/ms/user-group",
    //   text: formatMessage({ id: "group.user", defaultMessage: "User Group" }),
    //   icon: <People />,
    // },
  ];
  const itemUser: IListItemLinkProps[] = [
    {
      to: "/ms/process",
      text: formatMessage({
        id: "process.side.title",
        defaultMessage: "Process",
      }),
      icon: <Description />,
    },
    {
      to: "/ms/document",
      text: formatMessage({
        id: "component.sidebar.document",
        defaultMessage: "Document",
      }),
      icon: <Description />,
    },
  ];
  return (
    <div>
      <Sidebar
        title={formatMessage({
          id: "component.home.aptor-mls",
          defaultMessage: "Aptor - MS",
        })}
        sidebarOpen={props.sidebarOpen}
        handleSidebarToggle={props.handleSidebarToggle}
        items={userRole === "User" ? itemUser : itemClient}
      />
    </div>
  );
};
